import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import Spinner from '../Spinner/Spinner'
import { Input } from 'reactstrap'
import { SCHEMAS_QUERY } from '../../graphql'
import { publishEvent } from '../../utils'

const SCHEMAS = gql(SCHEMAS_QUERY)

export default function SchemaSelect({ handleChange }) {
  console.log('SchemaSelect rendered')

  function publishChange(e) {
    console.log('SchemaSelect: ', e.target.value)
    publishEvent('SCHEMA_SELECTED', e.target.value, 'SchemaSelect')
  }

  const changeFunction = handleChange ? (e) => handleChange(e) : (e) => publishChange(e)

  const { loading, error, data } = useQuery(SCHEMAS, { fetchPolicy: 'cache-first' })
  if (loading) {
    return <Spinner />
  }
  if (error) {
    return error.message
  }

  return (
    <Input type="select" name="schema" id="schema" bsSize="sm" onChange={(e) => changeFunction(e)} style={{ width: 'auto' }}>
      <option key={-1} value="">Select a schema...</option>
      {data.schemas.map(schema => (
        <option key={schema.name} value={schema.name}>
          {schema.name}
        </option>
      ))}
    </Input>
  )
}